import { render, staticRenderFns } from "./Monitoring2.vue?vue&type=template&id=22040c19"
import script from "./Monitoring2.vue?vue&type=script&lang=js"
export * from "./Monitoring2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports